import "./Layout.css";

import * as React from "react";

import { Alert, Col, Icon, Layout, Menu, Row } from "antd";

import CookieConsent from "./components/CookieeConsent";
import { DynamicBanner } from "./components/Banner";
import Footer from "./components/Footer";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import MainMenu from "./components/MainMenu";
import MobileTopLeftMenu from "./components/MobileTopLeftMenu";
import TopRightMenu from "./components/TopRightMenu";
import { breakpoints } from "../../constants";
import { css } from "@emotion/core";
import { environmentVariableList } from "../../config/env";
import queryString from "query-string";

const { Header, Content } = Layout;
const { SubMenu } = Menu;
interface Props {
  children: React.ReactNode;
}

const AppLayout: React.FC<Props> = ({ children }) => {
  const dealerBranded = queryString.parseUrl(window.location.search).query
    ?.utm_source;

  return (
    <Layout
      css={css`
        width: 100%;
        max-width: 1800px;
        margin: 0px auto;
        background: #fafafa;
      `}
    >
      {dealerBranded !== "jdpower" &&
        dealerBranded !== "lawtiger" &&
        dealerBranded !== "cycletrader" && (
          <>
            {/* <Header
              css={css`
                background: white;
                display: flex;
                z-index: 1;
                // border-bottom: 0.5px solid lightgray;
                box-shadow: 0px 1px 2px lightgray;
                padding: 5px !important;
                justify-content: space-between;
                align-items: center;
                @media (max-width: 1103px) {
                  display: none;
                }
              `}
            > */}
            {/* <a
                href="https://www.ridenow.com/"
                css={css`
                  overflow: hidden;
                  padding-left: 15px;
                `}
              >
                <img
                  alt="logo"
                  src={require("./images/ridenow-logo.png")}
                  css={css`
                    background-repeat: no-repeat;
                    background-position: 100%;
                    height: 66px;
                    width: 219px;
                    margin: 0 12px;
                    float: left;
                  `}
                />
              </a> */}
            {/* <Helmet>
                <script src="https://cdn.userway.org/widget.js" />
                <script id="google-analytics">
                  {` (function(d){
        var s = d.createElement("script");

        s.setAttribute("data-account", "qLb3sVM6fr");
        s.setAttribute("src", "https://cdn.userway.org/widget.js");
        (d.body || d.head).appendChild(s);
        })(document)`}
                </script>
              </Helmet>
              <MainMenu />
              <TopRightMenu /> */}
            {/* </Header> */}
            {/* <CookieConsent /> */}
            {/* <Header
              css={css`
                background: white;
                z-index: 1;
                padding: 0;
                @media (min-width: 1104px) {
                  display: none;
                }
              `}
            >
              <Row
                css={css`
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin: 0 0 0 25px;
                `}
              >
                <Col
                  css={css`
                    width: 100%;
                  `}
                >
                  <Link to="/" css={css``}>
                    <img
                      alt="logo"
                      src={require("./images/rumbleon-black-logo.svg")}
                      css={css`
                        background-repeat: no-repeat;
                        background-position: 100%;
                        height: 66px;
                        width: 190px;
                      `}
                    />
                  </Link>
                </Col> */}
            {/* <Col>
                  <MobileTopLeftMenu />
                </Col> */}
            {/* </Row>
            </Header> */}
          </>
        )}

      {/* Uncomment if need a banner for messages */}
      {/* <Row>
        <Col span={24}>
          <Alert
            message={`We are currently undergoing some new upgrades and enhancements to our inventory pages. Check back soon to see our large selection of Dealer Inventory.

`}
          />
        </Col>
      </Row> */}

      <Content
        css={css`
          padding: 0;
          @media (max-width: ${breakpoints.lg}) {
            padding: 0;
          }
        `}
      >
        {" "}
        <DynamicBanner />
        {children}
      </Content>
      {/* <PageDivider /> */}
      {/* {dealerBranded !== "jdpower" &&
        dealerBranded !== "lawtiger" &&
        dealerBranded !== "cycletrader" && <Footer />} */}
    </Layout>
  );
};

export default AppLayout;
